module.exports = __webpack_public_path__ + "img/importance.783b292e.svg";